import api from './api';

export const chamCongService = {
  getDanhMucLoai() {
    return api.get('/ChamCongKhoaPhong/danh-muc-loai');
  },

  getDanhMucLoaiPhu() {
    return api.get('/ChamCongKhoaPhong/danh-muc-loai-phu');
  },
  
  getBangCong(maKhoa: number, thang: number, nam: number) {
    return api.get('/ChamCongKhoaPhong/bang-cong', {
      params: { maKhoa, thang, nam }
    });
  },
  
  saveBangCong(data: any) {
    return api.post('/ChamCongKhoaPhong/save-bang-cong', data);
  },

  saveBangPhu(data: any) {
    return api.post('/ChamCongKhoaPhong/save-bang-phu', data);
  },

  saveKetQuaThang(data: any) {
    return api.post('/ChamCongKhoaPhong/save-ket-qua-thang', data);
  },
  
  getCauHinhCa(maKhoa?: number) {
    return api.get('/ChamCongKhoaPhong/cau-hinh-ca', {
      params: { maKhoa }
    });
  },
  
  getLuyKeNghi(maChamCong: string, denThang: number, denNam: number) {
    return api.get('/ChamCongKhoaPhong/luy-ke-nghi', {
      params: { maChamCong, denThang, denNam }
    });
  },

  syncFromHis(data: { thang: number, nam: number, maKhoa: number, maChamCongs?: string[] }) {
    return api.post('/Sync/his-timekeeping', data);
  },

  resetInit(data: { maChamCongs: string[], ngayBatDau: string, isDefault: boolean }) {
    return api.post('/ChamCongKhoaPhong/reset-init', data);
  },

  getSuggestions(maKhoa: number, thang: number, nam: number) {
    return api.get(`/ChamCongKhoaPhong/get-suggestions?maKhoa=${maKhoa}&thang=${thang}&nam=${nam}`);
  },

  getDanhMucChedo() {
    return api.get('/ChamCongKhoaPhong/danh-muc-chedo');
  },

  getNhanVienChedos(maChamCong: string, tuNgay: string, denNgay: string) {
    return api.get(`/ChamCongKhoaPhong/nv-chedos/${maChamCong}`, {
      params: { tuNgay, denNgay }
    });
  },

  saveNhanVienChedo(data: any) {
    return api.post('/ChamCongKhoaPhong/save-nv-chedo', data);
  },

  deleteNhanVienChedo(id: number) {
    return api.delete(`/ChamCongKhoaPhong/delete-nv-chedo/${id}`);
  }
};
